import NotificationsFlyout from '@weave-design/notifications-flyout';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
export const StyledNotificationsFlyout = styled(NotificationsFlyout) `
	button {
		svg {
			color: #ffffff;
		}
		svg path {
			fill: currentcolor;
		}
	}
	section {
		button {
			svg path {
				fill: #808080;
			}
		}
		> div {
			> div:last-child {
				:hover {
					background-color: #ffffff;
				}
				> div {
					border-left-width: 0;
				}
			}
		}
	}
`;
export const StyledNotificationsFlyoutWithToggle = styled(StyledNotificationsFlyout) `
	section {
		> div {
			> div:first-child {
				:hover {
					background-color: #ffffff;
				}
				> div {
					border-left-width: 0;
				}
			}
		}
	}
`;
export const StyledNotificationText = styled.p `
	margin-bottom: 7px !important;
`;
export const StyledLink = styled(Link) `
	display: inline-block;
	color: #016faf !important;
	font-weight: 500;
	text-decoration: none !important;
	margin-bottom: 7px;

	&:focus {
		outline: none !important;
	}
`;
